import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { IUpdateContactPayload } from "src/app/models/contact/update-contact-payload";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-edit-contact-modal",
  templateUrl: "./edit-contact-modal.component.html",
})
export class EditContactModalComponent {
  @Input() contact: IContact | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<IUpdateContactPayload>();

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.EditContact;
  }

  onClose() {
    this._modalService.closeModal();
    this.close.emit();
  }

  onSubmit(contact: IContact) {
    const updateContactPayload: IUpdateContactPayload = {
      oldName: this.contact?.name ?? "",
    };

    for (let [key, value] of Object.entries(contact)) {
      if (value !== this.contact?.[key as keyof IContact]) {
        updateContactPayload[key as keyof IContact] = value;
      }
    }

    this._modalService.closeModal();
    this.submit.emit(updateContactPayload);
  }
}
